export const bankCardLimitChange = {
    enabled: true,
    _description: 'Enables the bank card limit change feature on bank card settings page.',
};
